import Content from './Content';

export default Content;



// WEBPACK FOOTER //
// ./src/Main/components/Content/index.ts